import { FolderKanban, Rocket } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/atoms";
import { routesData } from "@/data";
import { t } from "@/hooks";

interface SelectionGuardProps {
    type: "no-projects" | "no-active-sprints";
}

export const SelectionGuard = ({ type }: SelectionGuardProps) => {
    const navigate = useNavigate();

    if (type === "no-projects") {
        return (
            <div className="flex flex-1 flex-col items-center justify-center py-16 text-center px-4">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted mb-4">
                    <FolderKanban className="h-8 w-8 text-text-muted" />
                </div>
                <h3 className="text-lg font-semibold text-text-dark mb-1">{t("No projects yet")}</h3>
                <p className="text-sm text-text-secondary max-w-sm mb-6">
                    {t("Create your first project to start organizing sprints.")}
                </p>
                <Button size="sm" onClick={() => navigate(routesData.projects)}>
                    {t("Go to Projects")}
                </Button>
            </div>
        );
    }

    return (
        <div className="flex flex-1 flex-col items-center justify-center py-16 text-center px-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted mb-4">
                <Rocket className="h-8 w-8 text-text-muted" />
            </div>
            <h3 className="text-lg font-semibold text-text-dark mb-1">{t("No active sprints")}</h3>
            <p className="text-sm text-text-secondary max-w-sm mb-6">
                {t("Create or activate a sprint to start tracking work in this project.")}
            </p>
            <Button size="sm" onClick={() => navigate(routesData.sprints)}>
                {t("Go to Sprints")}
            </Button>
        </div>
    );
};
